import React, { Fragment, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';

import './styles.scss';
import { ReactComponent as Logo } from 'assets/images/logo/tib-logo-blue.svg';
import useProfile from 'hooks/useProfile';
import { checkValidRole } from 'utilities/common';
import { removeDuplicatesArray } from 'utilities/common';
import Icon, { ChervonRightIcon } from 'components/Atoms/Icon';
import menu from './menu';

const { Sider } = Layout;
const { SubMenu } = Menu;

const SideBar = ({ collapsed = false }) => {
  const location = useLocation();

  const [menuSelected, setMenuSelected] = useState({
    selectKey: [],
    openKey: [],
  });

  const { data: userInfo } = useProfile();

  useEffect(() => {
    let temp = { ...menuSelected, selectKey: [] };
    const { pathname } = location;
    for (const item of menu) {
      if (
        item.path === pathname ||
        pathname.includes(item?.path?.replace(':id', ''))
      ) {
        temp = {
          selectKey: [item.name || item.parentName],
          openKey: [...menuSelected.openKey],
        };
        break;
      }
      if (item.children?.length) {
        for (const itemSub of item.children) {
          if (
            itemSub.path === pathname ||
            pathname.includes(itemSub?.path.replace(':id', ''))
          ) {
            temp = {
              selectKey: [itemSub.parentName || itemSub.name],
              openKey: [...menuSelected.openKey, item.name],
            };
            break;
          }
        }
      }
    }
    setMenuSelected({
      ...temp,
      openKey: removeDuplicatesArray(temp.openKey),
    });
  }, [location]);

  const renderMenu = () => {
    return (
      <Menu
        selectedKeys={menuSelected.selectKey}
        openKeys={menuSelected.openKey}
        mode="inline"
        id="sidebar-menu-custom"
        onOpenChange={(openKeys) =>
          setMenuSelected({ ...menuSelected, openKey: openKeys })
        }
        expandIcon={({ isOpen }) => {
          return (
            <div className="d-inline-block f-right">
              {isOpen ? (
                <CaretUpOutlined className="icon-expand" />
              ) : (
                <CaretDownOutlined className="icon-expand" />
              )}
            </div>
          );
        }}
      >
        {menu.map((m) => {
          if (m.children) {
            return renderSubMenu(m);
          }
          return renderMenuItem(m);
        })}
      </Menu>
    );
  };

  const renderSubMenu = (data) => {
    return (
      <SubMenu
        key={data.name}
        icon={<Icon component={data.icon} className="my-menu-icon" />}
        title={data?.name}
      >
        {data.children.map((d) => renderMenuItem(d, true))}
      </SubMenu>
    );
  };

  const renderMenuItem = (data, isSub) => {
    if (!data.showMenu || !checkValidRole(data.roles, userInfo?.role)) {
      return null;
    }
    return (
      <Fragment key={data.path}>
        <Menu.Item
          key={data.name}
          icon={
            <Icon
              component={isSub ? ChervonRightIcon : data.icon}
              className="my-menu-icon"
            />
          }
        >
          <Link to={data.path}>{data.name}</Link>
        </Menu.Item>

        {data.hasBorderBt && <div className="border-bt" />}
      </Fragment>
    );
  };

  return (
    <Sider collapsed={false} collapsedWidth={56} id="site-sidebar" width={230}>
      <Link to="/">
        <div className="logo-wrapper">
          <Logo />
        </div>
      </Link>
      {renderMenu()}
    </Sider>
  );
};

export default SideBar;
